<template>
	<div :class="isShow ? 'side-over--active' : ''">
		<div
			v-if="isShow"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="isShow = false"
		></div>
		<UpdateResultSideOver
			:data="dataResult"
			:refresh="isShow"
			:is-edit="isEdit"
			:student="student"
			@close="isShow = false"
			@success="success"
			@openCreate="openCreateModal = true"
			@openPlan="openPlan"
			@screening="openScreeningTitle"
		/>
	</div>
	<DaModalFrame v-model:open="isOpenModal">
		<ConfirmSend @close="isOpenModal = false" @submit="sendReport" />
	</DaModalFrame>
	<DaModalFrame v-model:open="openCreateModal">
		<CreateNewForm
			:student-id="id"
			:student-name="student && student.name"
			@close="openCreateModal = false"
		/>
	</DaModalFrame>
	<ScreeningTitleModal
		v-if="titleOpen"
		:scale-name="selectedScale && selectedScale.name"
		:default-title="defaultScreeningTitle"
		:error="titleError"
		:loading="creatingScreening"
		@close="titleOpen = false"
		@confirm="confirmScreening"
	/>
	<div v-if="!isLoading">
		<div
			v-if="result && result.length > 0"
			class="flex items-center justify-end"
		>
			<div
				v-if="
					!is_old_data &&
					['active', 'pending'].includes(student.state) &&
					((isAdmin && !enableAssessmentDocumentCreationRight) ||
						(enableAssessmentDocumentCreationRight &&
							hasAssessmentDocumentCreationRight))
				"
				class="my-6 ml-auto"
			>
				<button
					class="button-p btn--ghost w-fit flex items-center justify-center"
					type="button"
					@click="isShow = true"
				>
					<svg
						class="mr-2"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
							fill="currentColor"
							fill-rule="evenodd"
						/>
					</svg>
					Tạo mới
				</button>
			</div>
		</div>
		<div
			v-if="result && result.length > 0"
			class="shadow-sm sm:rounded-2xl"
		>
			<div class="__record__table overflow-x-auto scroll-bar">
				<div class="sm:rounded-t-2xl w-fit min-w-full">
					<table class="result-table divide-y text-neutral-200">
						<thead class="bg-neutral-100 h-16">
							<tr>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
									scope="col"
								>
									STT
								</th>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
									scope="col"
								>
									Tiêu đề
								</th>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									scope="col"
								>
									Trạng thái
								</th>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									scope="col"
								>
									Ngày thực hiện
								</th>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									scope="col"
								>
									Tuổi thực
								</th>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
									scope="col"
								>
									Kết luận
								</th>
								<th
									scope="col"
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
								>
									Tài liệu
								</th>
								<th
									class="p-4 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									scope="col"
								>
									Loại đánh giá
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, index) in result"
								:key="item.id || index"
								:class="
									index % 2 === 0
										? 'bg-white'
										: 'bg-neutral-50'
								"
								class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
								@click="openResult(item)"
							>
								<td class="px-4 py-4 whitespace-nowrap">
									{{ index + 1 }}
								</td>
								<td class="px-4 py-4 text-neutral-700 break-words">
									{{ rowTitle(item) }}
								</td>
								<td class="px-4 py-4 whitespace-nowrap">
									<div v-if="sentAt(item)">Đã gửi</div>
									<button
										v-else
										class="button-p text-center btn--ghost result-send"
										type="button"
										@click.stop="openModal(item)"
									>
										Gửi PH
									</button>
								</td>
								<td
									class="px-4 py-4 whitespace-nowrap text-neutral-700"
								>
									<div v-if="rowDate(item)">
										{{ $filters.formatDate2(rowDate(item)) }}
									</div>
								</td>
								<td
									class="px-4 py-4 whitespace-nowrap text-neutral-700"
								>
									{{ rowAge(item) }}
								</td>
								<td class="px-4 py-4 text-neutral-700 break-words">
									<div
										v-for="(line, lineIndex) in conclusionLines(
											item
										)"
										:key="lineIndex"
									>
										{{ line }}
									</div>
								</td>
								<td class="px-4 py-4 whitespace-nowrap">
									<div v-if="rowFiles(item).length">
										<svg
											@click.stop="
												downloadFileResult(item)
											"
											class="cursor-pointer text-blue-700 hover:text-blue-800"
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M10 0C8.21698 0 6.6397 0.70057 5.5072 1.67727C4.54981 2.50296 3.85599 3.57713 3.67778 4.65625C1.58233 5.1189 0 6.94389 0 9.14773C0 11.7075 2.13442 13.75 4.72656 13.75H9.375V6.875C9.375 6.52982 9.65482 6.25 10 6.25C10.3452 6.25 10.625 6.52982 10.625 6.875V13.75H15.8594C18.1279 13.75 20 11.9619 20 9.71591C20 7.6707 18.4476 6.00513 16.4571 5.72373C16.1541 2.4993 13.3628 0 10 0Z"
												fill="currentColor"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M9.55806 19.8169C9.80214 20.061 10.1979 20.061 10.4419 19.8169L14.1919 16.0669C14.436 15.8229 14.436 15.4271 14.1919 15.1831C13.9479 14.939 13.5521 14.939 13.3081 15.1831L10.625 17.8661V13.75H9.375V17.8661L6.69194 15.1831C6.44786 14.939 6.05214 14.939 5.80806 15.1831C5.56398 15.4271 5.56398 15.8229 5.80806 16.0669L9.55806 19.8169Z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</td>
								<td class="px-4 py-4 whitespace-nowrap">
									<span
										v-if="typeLabel(item)"
										class="type-badge"
										:class="typeClass(item)"
									>
										{{ typeLabel(item) }}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div
			v-else
			class="w-full h-full flex items-center justify-center flex-col"
		>
			<img
				alt=""
				src="@/assets/images/illustrations/screening-empty.svg"
			/>
			<div class="text-neutral-500 text-lg text-center mt-6">
				Học sinh chưa có bản đánh giá nào
			</div>
			<div
				class="text-neutral-500 text-center mt-4 w-full min-w-0 px-6"
				style="max-width: 520px"
			>
				Các bản đánh giá đã hoàn thành, bao gồm kết quả đánh giá, sàng
				lọc, đánh giá phát triển và đánh giá quá trình can thiệp sẽ
				được lưu trữ tại đây.
			</div>
			<div
				v-if="
					!is_old_data &&
					['active', 'pending'].includes(student.state) &&
					((isAdmin && !enableAssessmentDocumentCreationRight) ||
						(enableAssessmentDocumentCreationRight &&
							hasAssessmentDocumentCreationRight))
				"
				class="mt-8"
			>
				<button
					class="button-p btn--ghost w-fit"
					type="button"
					@click="isShow = true"
				>
					<span class="whitespace-nowrap">Tạo mới</span>
				</button>
			</div>
		</div>
	</div>
	<div v-else class="fixed top-1/2 left-1/2">
		<Loading />
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { $api } from '@/services';
import UpdateResultSideOver from './UpdateResultSideOver';
import downloadFile from '@/mixins/downloadCSV.vue';
import Loading from '@/components/common/Loading';
import ConfirmSend from '@/views/planPreview/ConfirmSend.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import CreateNewForm from '@/views/record/studentDetail/features/result/CreateNewForm.vue';
import ScreeningTitleModal from '@/views/screening/features/ScreeningTitleModal.vue';
import { _ROUTER_NAME } from '@/enums';

export default defineComponent({
	name: 'Result',
	components: {
		Loading,
		UpdateResultSideOver,
		ConfirmSend,
		DaModalFrame,
		CreateNewForm,
		ScreeningTitleModal,
	},
	data() {
		return {
			result: [],
			isShow: false,
			isLoading: true,
			isEdit: false,
			dataResult: {
				age: null,
				assessment_conclusions: [],
				assessment_date: '',
				development_ages: [],
				prescription: [],
				files: [],
				id: '',
				name: '',
				note: '',
			},
			reportId: null,
			reportIsScreening: false,
			isOpenModal: false,
			openCreateModal: false,
			titleOpen: false,
			titleError: '',
			creatingScreening: false,
			selectedScale: null,
		};
	},
	props: {
		student: {
			type: Object,
			default() {
				return {
					id: '',
					state: '',
				};
			},
		},
	},

	mixins: [downloadFile],

	computed: {
		id() {
			return Number(this.$route.params.id);
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		oldPayload() {
			return {
				'x-cross': this.$route.query.org_id,
			};
		},
		is_old_data() {
			return this.$route.query.is_old_data === 'true';
		},
		enableAssessmentDocumentCreationRight() {
			return this.$store.state.profile.current_org
				.enable_assessment_document_creation_right;
		},
		hasAssessmentDocumentCreationRight() {
			return this.$store.state.profile
				.has_assessment_document_creation_right;
		},
		defaultScreeningTitle() {
			const name = (this.selectedScale?.name || '').replace(
				/^thang\s+/i,
				''
			);
			return `Thang sàng lọc ${name} - ${
				this.student?.name || ''
			}`.trim();
		},
	},

	created() {
		this.fetchResult();
	},

	methods: {
		downloadFileResult(item) {
			if (this.screeningData(item)) {
				this.rowFiles(item).forEach((file) => {
					const url = this.fileUrl(file);
					if (url) window.open(url, '_blank');
				});
				return;
			}
			this.fetchResultDetail(item.id);
		},
		fileUrl(file) {
			if (!file) return '';
			if (typeof file === 'string') return file;
			return file.url || file.file_url || file.link || file.path || '';
		},
		screeningData(item) {
			const scale = item?.screening_scale;
			if (!scale || typeof scale !== 'object' || Array.isArray(scale)) {
				return null;
			}
			return scale;
		},
		pick(item, keys) {
			const sources = [this.screeningData(item), item].filter(Boolean);
			for (let i = 0; i < keys.length; i++) {
				const key = keys[i];
				for (let j = 0; j < sources.length; j++) {
					const value = sources[j][key];
					if (value !== null && value !== undefined && value !== '') {
						return value;
					}
				}
			}
			return '';
		},
		rowTitle(item) {
			return this.pick(item, ['title', 'name']);
		},
		rowDate(item) {
			return this.pick(item, ['assessment_date', 'date']);
		},
		rowAge(item) {
			return this.pick(item, ['display_age', 'age']);
		},
		rowFiles(item) {
			const scale = this.screeningData(item);
			if (scale && Array.isArray(scale.files)) return scale.files;
			return Array.isArray(item?.files) ? item.files : [];
		},
		sentAt(item) {
			const scale = this.screeningData(item);
			if (scale && Object.prototype.hasOwnProperty.call(scale, 'sent_at')) {
				return scale.sent_at;
			}
			return item?.sent_at;
		},
		screeningLinkId(item) {
			const scale = this.screeningData(item);
			if (!scale) return null;
			return (
				scale.student_screening_scale_id ||
				scale.student_screening_scale?.id ||
				item.student_screening_scale?.id ||
				item.student_screening_scale_id ||
				scale.id ||
				item.id
			);
		},

		async fetchResultDetail(id) {
			try {
				const { data } = await $api.student.assessmentDocumentDetail(
					this.id,
					id,
					this.is_old_data ? this.oldPayload : null
				);
				this.downloadFileAsZip(data.data.files);
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async fetchResult() {
			try {
				const { data } = await $api.student.assessmentDocuments(
					this.id,
					this.is_old_data ? this.oldPayload : null,
					{ state: 'completed' }
				);
				this.result = data.data || [];
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isLoading = false;
			}
		},
		editResult(result) {
			this.dataResult = result;
			this.dataResult.showNote = result.period_report ? true : false;
			this.isShow = true;
			this.isEdit = true;
		},
		success() {
			this.fetchResult();
			this.isShow = false;
			this.isEdit = false;
			this.dataResult = {};
		},
		documentType(item) {
			if (this.screeningData(item)) return 'screening_scale';
			return item.assessment_document_type || item.type || '';
		},
		typeLabel(item) {
			const scale = this.screeningData(item);
			if (scale) {
				return (
					scale.display_assessment_document_type || 'Thang sàng lọc'
				);
			}
			if (item.display_assessment_document_type) {
				return item.display_assessment_document_type;
			}
			const labels = {
				assessment_document: 'Hồ sơ thăm khám',
				period_report: 'Tổng hợp kết quả CT',
				ai_period_report: 'Đánh giá kết quả CT',
				assessment_form: 'Đánh giá phát triển',
				screening_scale: 'Thang sàng lọc',
			};
			return labels[this.documentType(item)] || '';
		},
		typeClass(item) {
			const classes = {
				assessment_document: 'type-badge--document',
				period_report: 'type-badge--period',
				ai_period_report: 'type-badge--ai',
				assessment_form: 'type-badge--form',
				screening_scale: 'type-badge--screening',
			};
			return classes[this.documentType(item)] || 'type-badge--form';
		},
		conclusionText(value) {
			if (value === null || value === undefined || value === '') return '';
			if (typeof value === 'string' || typeof value === 'number') {
				return String(value);
			}
			return value.label || value.name || value.title || '';
		},
		conclusionLines(item) {
			const sources = [this.screeningData(item), item].filter(Boolean);
			for (let i = 0; i < sources.length; i++) {
				const value = sources[i].assessment_conclusions;
				if (Array.isArray(value) && value.length) {
					return value
						.map((line) => this.conclusionText(line))
						.filter(Boolean);
				}
			}
			for (let i = 0; i < sources.length; i++) {
				const text = this.conclusionText(sources[i].conclusion);
				if (text) return [text];
			}
			return [];
		},
		openResult(item) {
			const screeningId = this.screeningLinkId(item);
			if (screeningId) {
				this.$router.push({
					name: _ROUTER_NAME.SCREENING_TAKE,
					params: {
						studentId: this.id,
						screeningId,
					},
					query: { view: 'detail' },
				});
				return;
			}
			const query = {};
			if (item?.period_report?.start_date) {
				query.start_date = item.period_report.start_date;
			}
			if (item?.period_report?.end_date) {
				query.end_date = item.period_report.end_date;
			}
			if (item?.student_assessment_form) {
				query.student_form = true;
				query.formId = item.student_assessment_form.id;
			}
			this.$router.push({
				path: `/record/student/${this.id}/result/${item.id}`,
				query,
			});
		},
		openPlan() {
			this.isShow = false;
			this.$router.push({
				name: _ROUTER_NAME.RECORD_STUDENT_DETAIL_PLAN,
				params: { id: this.id },
				query: { ...this.$route.query },
			});
		},
		openScreeningTitle(scale) {
			this.selectedScale = scale;
			this.titleError = '';
			this.titleOpen = true;
		},
		async confirmScreening(title) {
			if (!this.selectedScale || this.creatingScreening) return;
			this.creatingScreening = true;
			this.titleError = '';
			try {
				const res = await $api.screening.create(this.id, {
					student_id: this.id,
					screening_scale_id: this.selectedScale.id,
					title,
				});
				const body = res?.data?.data || res?.data || {};
				const screeningId =
					body.id || body.student_screening_scale?.id;
				this.titleOpen = false;
				this.isShow = false;
				this.$router.push({
					name: _ROUTER_NAME.SCREENING_TAKE,
					params: {
						studentId: this.id,
						screeningId,
					},
				});
			} catch (err) {
				const errors = err?.response?.data?.errors;
				const text = Array.isArray(errors)
					? errors.join(' ')
					: err?.response?.data?.error ||
					  err?.response?.data?.message ||
					  '';
				this.titleError = /trùng|duplicate|taken|tiêu đề|title/i.test(
					text
				)
					? 'Tiêu đề không được trùng với tiêu đề đã có'
					: text || 'Đã có lỗi xảy ra. Vui lòng thử lại';
			} finally {
				this.creatingScreening = false;
			}
		},
		openModal(item) {
			this.isOpenModal = true;
			this.reportIsScreening = !!this.screeningData(item);
			this.reportId = this.screeningLinkId(item) || item.id;
		},
		async sendReport() {
			try {
				const res = this.reportIsScreening
					? await $api.screening.send(this.id, this.reportId)
					: await $api.staff.sendAssessmentDocument(
							this.id,
							this.reportId
					  );
				if (res) {
					await this.$store.dispatch('setAlertMessage', {
						message: 'Gửi tới phụ huynh thành công',
						type: 'success',
					});
					this.fetchResult();
				}
				this.isOpenModal = false;
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
	},
});
</script>

<style scoped>
.result-table {
	border-collapse: separate;
	border-spacing: 0;
}

.result-table th,
.result-table td {
	overflow-wrap: anywhere;
	word-break: break-word;
	vertical-align: top;
}

.result-table th:nth-child(1),
.result-table td:nth-child(1),
.result-table th:nth-child(3),
.result-table td:nth-child(3),
.result-table th:nth-child(4),
.result-table td:nth-child(4),
.result-table th:nth-child(5),
.result-table td:nth-child(5),
.result-table th:nth-child(7),
.result-table td:nth-child(7),
.result-table th:nth-child(8),
.result-table td:nth-child(8) {
	width: 1%;
	white-space: nowrap;
}

.result-table th:nth-child(2),
.result-table td:nth-child(2) {
	min-width: 10rem;
	max-width: 16rem;
}

.result-table th:nth-child(6),
.result-table td:nth-child(6) {
	min-width: 12rem;
	max-width: 18rem;
}

.result-send {
	width: auto;
	min-width: 0;
	padding: 8px 12px;
	font-size: 12px;
	line-height: 16px;
	color: #d89210;
	border-color: #d89210;
}

.type-badge {
	display: inline-flex;
	align-items: center;
	padding: 8px 12px;
	border-radius: 100px;
	font-size: 12px;
	font-weight: 600;
	line-height: 16px;
	white-space: nowrap;
}

.type-badge--form {
	background: #fcf1da;
	color: #d89210;
}

.type-badge--screening {
	background: #fbece2;
	color: #e77b35;
}

.type-badge--ai {
	background: #e8f9f7;
	color: #2aa797;
}

.type-badge--period {
	background: #f7fee7;
	color: #65a30d;
}

.type-badge--document {
	background: #eef3f8;
	color: #6390c3;
}
</style>
